import * as React from 'react';
import Navigation from './Navigation';
import Content from './Content';
import { Config } from '../helper';
import { Code } from 'react-content-loader';
function NavigationToggler(props) {
  const { sidebarRef } = props;
  const el = React.useRef(null);

  React.useEffect(() => {
    const toggleVisibility = () => { el.current.classList.toggle('expanded') }
    if (el.current) {
      el.current.addEventListener('click', toggleVisibility);
    }

    return () => {
      el?.current.removeEventListener('click', toggleVisibility);
    }
  }, []);

  return (
    <div className='nv-learning-pathway-navigation-toggler' ref={el}>
      <div className='container'>
        <div className='row'>
          <div className='col'>
            <button>{Config.I18n.OnThisPage}</button>
            <Navigation />
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Layout(props) {
  return (
    <div className='nv-learning-pathway-layout'>
      <NavigationToggler />
      <div className='container'>
        <div className='row'>
          <div className='col-3 nv-learning-pathway-layout__sidebar'>
            <Navigation />
          </div>
          <div className='col-9 nv-learning-pathway-layout__content'>
            <Content />
          </div>
        </div>
      </div>
    </div>
  );
}

export function LayoutPreloader(props) {
  return (
    <div className='nv-learning-pathway-layout'>
      <div className='container'>
        <div className='row'>
          <div className='col-3 nv-learning-pathway-layout__sidebar'>
            <Code/>
          </div>
          <div className='col-5 nv-learning-pathway-layout__content'>
            <div className='mb-3'><Code/></div>
            <div className='mb-3'><Code/></div>
            <div className='mb-3'><Code/></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function LayoutFallback(props) {
  return (
    <div className='nv-learning-pathway-layout'>
      <div className='container'>
        <div className='row'>
          <div className='col-12 nv-learning-pathway-layout__content'>
            <p className='p--large'>{Config.I18n.Errors.ConfigNotLoaded}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
